import { useState, useEffect } from 'react';
import { Card, Table, Button, message, Modal, Form, Input, Select, Space, Popconfirm, Tag } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import axios from 'axios';

const API = import.meta.env.VITE_API_BASE || '/api';
const token = () => localStorage.getItem('ar_token');
const h = () => ({ Authorization: 'Bearer ' + token() });

export default function StaffManagement() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const fetchStaff = async () => {
    setLoading(true);
    try {
      const r = await axios.get(API + '/admin/staff', { headers: h() });
      if (r.data.success) setStaff(r.data.data || []);
    } catch (e) {
      message.error('加载人员失败');
    } finally { setLoading(false); }
  };

  useEffect(() => { fetchStaff(); }, []);

  const handleAdd = async () => {
    try {
      const vals = await form.validateFields();
      setSubmitting(true);
      await axios.post(API + '/admin/staff', vals, { headers: h() });
      message.success('人员已添加');
      setModalOpen(false);
      form.resetFields();
      fetchStaff();
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e.response?.data?.detail || '添加失败');
    } finally { setSubmitting(false); }
  };

  const handleDelete = async (cCusCode) => {
    try {
      await axios.delete(API + '/admin/staff/' + encodeURIComponent(cCusCode), { headers: h() });
      message.success('已删除');
      fetchStaff();
    } catch (e) {
      message.error(e.response?.data?.detail || '删除失败');
    }
  };

  const columns = [
    { title: '人员编码', dataIndex: 'cCusCode' },
    { title: '姓名', dataIndex: 'ccusname' },
    {
      title: '角色', dataIndex: 'role', render: (v, r) => (
        <Tag color={v === 3 ? 'red' : 'blue'}>{r.roleName || (v === 3 ? '管理员' : '商务人员')}</Tag>
      ),
    },
    {
      title: '操作', width: 120, render: (_, r) => (
        <Popconfirm title={`确定删除人员「${r.ccusname || r.cCusCode}」？`} onConfirm={() => handleDelete(r.cCusCode)}>
          <Button size="small" danger icon={<DeleteOutlined />}>删除</Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Card
      title="人员管理"
      extra={<Button type="primary" icon={<PlusOutlined />} onClick={() => { form.resetFields(); setModalOpen(true); }}>添加人员</Button>}
    >
      <Table dataSource={staff} rowKey="cCusCode" columns={columns} loading={loading} size="small"
        pagination={false} />

      <Modal title="添加人员" open={modalOpen} onOk={handleAdd} confirmLoading={submitting}
        onCancel={() => setModalOpen(false)} destroyOnClose>
        <Form form={form} layout="vertical" initialValues={{ role: 4 }}>
          <Form.Item name="cCusCode" label="人员编码（登录账号）" rules={[{ required: true, message: '请输入人员编码' }]}>
            <Input placeholder="例如：sales01" />
          </Form.Item>
          <Form.Item name="ccusname" label="姓名" rules={[{ required: true, message: '请输入姓名' }]}>
            <Input placeholder="请输入姓名" />
          </Form.Item>
          <Form.Item name="role" label="角色" rules={[{ required: true, message: '请选择角色' }]}>
            <Select options={[
              { value: 3, label: '管理员' },
              { value: 4, label: '商务人员' },
            ]} />
          </Form.Item>
          <Form.Item name="password" label="登录密码" rules={[{ required: true, min: 6, message: '密码至少6位' }]}>
            <Input.Password placeholder="请输入登录密码（至少6位）" />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
}
